





















import PluginComponent from '@/components/plugins/PluginComponent';
import CesiumMapService from '@/services/CesiumMapService';
import {  EVENTS } from '@/services/EventBus';
import MapService from '@/services/MapService';
import axios, { Canceler } from 'axios';
import GeoJSON from 'ol/format/GeoJSON';
import Component from 'vue-class-component';
import { getCenter } from 'ol/extent';

export const NOMINATIM = 'nominatim';
export const GEOPLATEFORME = 'Geoplateforme';

@Component
export default class ApiAdressePlugin extends PluginComponent {
  addresses= [];

  addressSearch= '';

  selectedAddress:any= null;

  marker:any = null;

  service = '';

  baseURL:any = '';

  baseUrl2 = '';

  extraURL = '';

  limitMap = false;

  viewbox = '';

  placeholder = 'Entrez une adresse'

  helperTxt = "Veuillez saisir l'adresse souhaité"

  bbox:number[] = [];
  geojsonFormat = new GeoJSON()
  private cancelRequest: Canceler | null = null;

  beforeDestroy(): void {
    this.getEventBus().$off(EVENTS.MAP_CURRENT_BBOX_CHANGE, this.changeBbox);
  }

  getBaseUrl (): string {
    this.service = this.plugin.getParameterValue('service');
    if(this.service === GEOPLATEFORME){
      this.placeholder ='Rechercher un lieu ou une adresse';
      this.helperTxt= "Veuillez saisir l'adresse ou le lieux souhaité";
      return 'https://data.geopf.fr/geocodage/search?index=poi,address&q='
    }else{
        return this.service === NOMINATIM
          ? 'https://nominatim.openstreetmap.org/search.php?format=geojson&q='
          : 'https://data.geopf.fr/geocodage/search/?q=';
      }
    }


  mounted(): void {
   
    this.getEventBus().$on(EVENTS.MAP_CURRENT_BBOX_CHANGE, this.changeBbox);
    this.changeBbox(this.getMapService().getMapBoundsWGS84());
    this.service = this.plugin.getParameterValue('service');
    this.baseURL = this.getBaseUrl()
   
    
    this.limitMap = this.service === NOMINATIM && this.plugin.getParameterValue('viewbox');
    const limit = this.plugin.getParameterValue('result-count');
    this.extraURL = `&limit=${limit}`;
    const extra = this.plugin.getParameterValue('extra');
    if (extra) {
      this.extraURL += `&${extra}`;
    }
    this.changeViewbox();
  }

  changeViewbox():void {
    if (this.limitMap) {
      this.viewbox = `&viewbox=${this.bbox}&bounded=1`;
    } else {
      this.viewbox = '';
    }
  }

  changeBbox(bbox:any):void {
    const coords:number[] = [];
    coords[0] = parseFloat(bbox[0].toFixed(5));
    coords[1] = parseFloat(bbox[1].toFixed(5));
    coords[2] = parseFloat(bbox[2].toFixed(5));
    coords[3] = parseFloat(bbox[3].toFixed(5));
    this.bbox = coords;
    this.changeViewbox();
  }

  selectAddresse(event:any):void {
    console.log(event);
    this.selectedAddress = event;
    if (this.selectedAddress !== null && (this.selectedAddress.geometry||(this.selectedAddress.properties && this.selectedAddress.properties['type'] === 'wfs'))) {
      let zoomlevel = 14;
      const { type } = this.selectedAddress.properties;
      if (type === 'housenumber') {
        zoomlevel = 19;
      } else if (type === 'street') {
        zoomlevel = 16;
      } else if (type === 'locality') {
        zoomlevel = 16;
      } else if (type === 'municipality') {
        zoomlevel = 14;
      }
      else if (type === 'wfs') {
        this.contextService.configuration.apiAdresse.loadFeature(this.selectedAddress.properties['toponym'],'EPSG:4326').then((retour) => {
          this.addToMap(retour.data.features[0].geometry,zoomlevel);
        })
        return;
      }

     this.addToMap(this.selectedAddress.geometry,zoomlevel);
    }
    else if(this.getMapService() instanceof MapService){
      this.getMapService().addOverlay([0,0]);
    }
  }
  addToMap(geometry:any,zoomlevel:number):void {
     // On fait le zoom
       let extent = this.geojsonFormat.readGeometry(geometry).getExtent()
        var center = getCenter(extent);
      if(this.getMapService() instanceof CesiumMapService){
        this.getCesiumMapService().zoomTo(center, zoomlevel)
      }else{
        //let location = this.geojsonFormat.readFeature(this.selectedAddress);
       
        this.getMapService().zoomTo(center, zoomlevel);
        // On ajoute un point pour localiser la ville
        this.marker = this.getMapService().addOverlay(center);
      }
  }
  getAddresses(query:string, loading:(monParametre: boolean) => void):void {
    console.log('get addresses');
    // Annulez la requête précédente si elle existe
    if (this.cancelRequest) {
      this.cancelRequest();
    }
    // Créez une nouvelle fonction d'annulation pour la nouvelle requête
    const { token, cancel } = axios.CancelToken.source();
    this.cancelRequest = cancel;
    if(query.length == 0){
      this.addresses = [];
      return;
    }
    loading(true);
    
    let configuration = this.contextService.configuration;
    let wfsquery = null;
    let attributeSearch ="";
    if(configuration.apiAdresse){
      this.service = configuration.apiAdresse.label;
      this.baseURL = configuration.apiAdresse.wfsUrl;
      let layer = configuration.apiAdresse.layer;
      
      attributeSearch = configuration.apiAdresse.attributeSearch;
      wfsquery = configuration.apiAdresse.loadDatas(query,'',10);
    }
    
    let normalQuery = axios.get(`${this.getBaseUrl()}${query}${this.viewbox}${this.extraURL}`, {
      cancelToken: token, // Associez le token d'annulation à la requête
    });

      // On lance les deux requêtes en parallèle
      Promise.all([wfsquery, normalQuery]).then(([wfsretour, normalretour]:any) => {
        if(wfsretour){
          console.log(wfsretour.data.features);
          console.log(normalretour.data.features);
          let result = wfsretour.data.features.map((x:any) => {
            return {geometry:x.geometry,properties:{'type':'wfs',
            'label':x.properties[attributeSearch],
            'display_name':x.properties[attributeSearch],
            'toponym':x.properties[attributeSearch]}}
            });
          console.log(result);
          this.addresses = [...result, ...normalretour.data.features] as any;
        }else{
          this.addresses = normalretour.data.features;
        }
      }).catch((error) => {
        // Si la requête est annulée alors on ne met pas à jour les adresses
        if (!axios.isCancel(error)) {
          this.addresses = [];
        }
      }).finally(() => loading(false));
  }

  getOptionLabel(s:any):string {
    console.log(s);
    if(this.service === GEOPLATEFORME){
      return s.properties.toponym ? s.properties.toponym : s.properties.label;
    }
    return this.service === NOMINATIM ? s.properties.display_name : s.properties.label;
  }
}
